import _ from 'lodash';

export default ({ cloudfrontUrl }) => data => {
  const content = _.cloneDeep(data);
  const imageEntityMap = _.pickBy(
    content && content.entityMap,
    ({ type }) => type === 'IMAGE',
  );
  const entityMap = _.pickBy(
    content && content.entityMap,
    ({ type }) => type !== 'IMAGE',
  );
  const imageEntityMapKeys = _.keys(imageEntityMap);

  const blocks = _.map(content && content.blocks, block => {
    if (
      block.type !== 'atomic' &&
      !_.includes(_.map(block.entityRanges, 'key'), imageEntityMapKeys)
    ) {
      return block;
    }

    const newBlock = {
      ...block,
    };

    const entityMapImageKey = _.find(imageEntityMapKeys, item =>
      _.includes(
        _.map(newBlock.entityRanges, ({ key }) => `${key}`),
        item,
      ),
    );

    newBlock.entityRanges = _.filter(
      block.entityRanges,
      ({ key }) => key !== entityMapImageKey,
    );
    newBlock.type = 'atomic:image';
    newBlock.data = {
      ...(imageEntityMap[entityMapImageKey]
        ? imageEntityMap[entityMapImageKey].data
        : {}),
    };
    if (newBlock.data.src) {
      newBlock.data.src = `${cloudfrontUrl}${(newBlock.data.src || '').replace(
        '/cloudfront',
        '',
      )}`;
      newBlock.data.align = newBlock.data.alignment;
      newBlock.data.width = newBlock.data.width && `${newBlock.data.width}%`;
    }

    if (newBlock.data.align === 'center') {
      newBlock.data.style = { margin: '0 auto' };
    }

    return newBlock;
  });

  return {
    blocks,
    entityMap: entityMap || {},
  };
};
